import React, { FC, useCallback, useState } from 'react'
import { Box, Grid } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { ToggleButtons } from '../../../../../components/Dashboard/Buttons/ToggleButtons'
import { TradingBalances } from '../TreasurySections/TradingBalances'
import { ExecutorsFunds } from '../TreasurySections/ExecutorsFunds'
import { Activity } from '../TreasurySections/Activity'
import { GridRow } from '../../../../../components/GridRow'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  toggleWrap: {
    marginTop: theme.spacing(4),
    textAlign: 'center',
  },
}))

export const AllocateFunds: FC = () => {
  const classes = useStyles()
  const [selectedView, setSelectedView] = useState<string>('funds')
  const getSelectedView = useCallback((value: string) => setSelectedView(value), [])

  return (
    <Box className={classes.container}>
      <Box className={classes.toggleWrap}>
        <ToggleButtons getSelectedView={getSelectedView} />
      </Box>

      {selectedView === 'funds' ? (
        <GridRow spacing={4}>
          <Grid item xs={4}>
            <Grid item xs={12}>
              <TradingBalances title={'Total Company Trading Balances'} /* hideSettlementButton */ />
            </Grid>
            <Grid item xs={12}>
              <TradingBalances
                title={'Unallocated Company Trading Balances'} /* hideFundButton hideSettlementButton  */
              />
            </Grid>
          </Grid>
          <Grid item xs={8}>
            <ExecutorsFunds title={'Executors'} />
          </Grid>
        </GridRow>
      ) : (
        <GridRow spacing={4}>
          <Grid item xs={4}>
            <Activity />
          </Grid>
          <Grid item xs={8}>
            <ExecutorsFunds title={'Executors'} />
          </Grid>
        </GridRow>
      )}
    </Box>
  )
}
